import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
/**
 * Reset the feed, clearing out all items
 * */

export var resetFeed = createAction('resetFeed');
/**
 * Fetch statement-indexed feed
 *
 * @param {Object} params - Request parameters
 * @param {string[]} params.onlyTemplates - A list of templates supported by the client (omit to return all)
 * @param {string} params.clientPlatform - The type of client making the request "web" or "native"
 * */

export var getStatementIndexedFeed = createAsyncAction('getStatementIndexedFeed', function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      serverRequest = _ref.serverRequest,
      onlyTemplates = _ref.onlyTemplates,
      clientPlatform = _ref.clientPlatform;

  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.FeedSDK.getStatementIndexedFeed({
        onlyTemplates: onlyTemplates,
        clientPlatform: clientPlatform
      }, serverRequest);
    }
  };
});
export var removeFeedItemsFromStatementIndexedFeed = createAction('removeFeedItemsFromStatementIndexedFeed', function (ids) {
  return {
    ids: ids
  };
});